import React, { useEffect, useState } from "react";
import AddCitiesAndService from "./addCitiesAndService";
import AddRestStop from "./addRestStop";
import { opdbGTM } from "../../utils/pulseUtils";

const RestStopConfiguration = () => {
  const [addRestStopScreenActive, setAddRestStopScreenActive] = useState(false);
  useEffect(() => {
    opdbGTM.tabClicked("od_rest_stops_tab_clicked");
  }, []);
  return (
    <div>
      {!addRestStopScreenActive ? <AddCitiesAndService /> : <AddRestStop />}
    </div>
  );
};

export default RestStopConfiguration;
